export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";